export default __webpack_public_path__ + "static/media/MarsCentra-Book.c2a09d3b.ttf";